<template>
  <router-view :me="me"></router-view>
</template>

<script>
export default {
  name: "Settings",
  props: ["me"]
};
</script>